import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import SEOHead from "@/components/SEOHead";

export default function AllServicesPage() {
  return (
    <>
      <SEOHead
        title="Leistungen – EasyRohbau | Rohbau, Beton, Keller, Mauerwerk"
        description="Alle Rohbau-Leistungen von EasyRohbau: Rohbauarbeiten, Betonarbeiten, Schalung, Fundamente, Mauerwerk, Kellerbau, Decken, Sanierung und mehr."
      />
      <section className="pt-32 pb-12 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Leistungen</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0C2749] tracking-tight max-w-3xl" style={{ fontFamily: "Outfit" }}>
            Vollständiger Rohbau – aus einer Hand.
          </h1>
          <p className="text-slate-600 max-w-2xl mt-6">
            Vom Aushub bis zum bezugsfähigen Rohbau. Wählen Sie Ihre Leistung und erhalten Sie eine sofortige Kostenindikation.
          </p>
        </div>
      </section>

      <section className="bg-white pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s) => (
            <Link
              key={s.slug}
              to={`/leistungen/${s.slug}`}
              data-testid={`leistung-${s.slug}`}
              className="group bg-white border border-slate-200 hover:border-[#2873B8] hover:shadow-lg shadow-[#0C2749]/5 transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-2">
                  <h2 className="text-xl font-semibold text-[#0C2749]" style={{ fontFamily: "Outfit" }}>{s.title}</h2>
                  <ArrowUpRight className="w-4 h-4 text-slate-400 group-hover:text-[#2873B8] group-hover:rotate-45 transition-all" />
                </div>
                <p className="text-sm text-slate-600">{s.short}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
